module.exports = __webpack_public_path__ + "static/media/wanessa.0d7c667d.jpg";